import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const CircularIndeterminate = () => {
  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', paddingTop: '1rem' }}
    >
      <CircularProgress />
    </div>
  );
};

export default CircularIndeterminate;
